// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".automation-item[data-v-7a2190e9]{border-bottom:1px solid #bdbdbd;cursor:pointer;transition:box-shadow 250ms}.automation-item .icon[data-v-7a2190e9]{visibility:hidden;transition:visibility 50ms}.automation-item .icon[data-v-7a2190e9]:hover{color:#0bf}.automation-item[data-v-7a2190e9]:hover{background-color:rgba(0,0,0,.04)}.automation-item:hover .icon[data-v-7a2190e9]{visibility:visible}", ""]);
// Exports
module.exports = exports;
